module.exports = __webpack_public_path__ + "static/media/ph_logo.c9f60b15.jpg";